import React from "react";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import IbanCheckoutForm from "./IbanCheckoutForm";

const stripePromise = loadStripe(process.env.REACT_APP_PUBLIC_STRIPE_KEY);

const IbanCheckout = ({ initialData }) => {
  return (
    <Elements stripe={stripePromise}>
      <IbanCheckoutForm data={initialData} />
    </Elements>
  );
};

export default IbanCheckout;
